
import React, { useEffect, useState } from "react";
import Nav from "./Nav";
import Button from "./Button";
import iasgMidTermLogo from "../assets/images/iasg_mid_logo.png";

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    handleScroll(); // set initial state on load
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header className={`header ${isScrolled ? "is-scrolled" : ""}`}>
      <div className="container header-inner">
        <a
          href="#overview"
          className="header-logo"
          aria-label="IASG Mid-Term Conference 2026 home"
        >
          {/* <span className="header-logo-icon">IASG</span> */}
          <img src={iasgMidTermLogo} alt="IASG Mid-Term Conference 2026" className="header-logo-image" />
          <span className="header-logo-text">Mid-Term Conference 2026</span>
        </a>

        <Nav />

        <Button
          variant="primary"
          className="header-cta"
          // href="#registration"
          iconLeft="ri-star-line"
          onClick={() => {
            window.open("https://iasg.register.enhance.events/midtermconference2026", "_blank");
          }}
        >
          Register Now
        </Button>
      </div>
    </header>
  );
}

export default Header;

